import { render, staticRenderFns } from "./faceAuth.vue?vue&type=template&id=c39f76d6"
import script from "./faceAuth.vue?vue&type=script&lang=js"
export * from "./faceAuth.vue?vue&type=script&lang=js"
import style0 from "./faceAuth.vue?vue&type=style&index=0&id=c39f76d6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports